module.exports = __webpack_public_path__ + "static/dd369df5.shopify_auto_fulfill.webp";